import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";

function App() {
  return (
    <ErrorBoundary>
    <div className="App min-h-screen bg-[#080808] text-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0C0C0C",
            border: "1px solid rgba(212,175,55,0.25)",
            color: "#fff",
            borderRadius: "0",
          },
        }}
      />
    </div>
    </ErrorBoundary>
  );
}

export default App;
